
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#5FB8EE","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('g',{attrs:{"stroke-width":"2"}},[_c('path',{attrs:{"d":"M42 54.5H14.268a2.75 2.75 0 01-2.748-2.75v-39.5a2.75 2.75 0 012.748-2.75h26c1.52 0 2.75 1.23 2.752 2.75v15.244"}}),_c('path',{attrs:{"d":"M32.02 36.5h-13a1.5 1.5 0 00-1.5 1.5v9a1.5 1.5 0 001.5 1.5h14m-15.5-6h13.5m-4.5-6v12"}})]),_c('path',{attrs:{"d":"M22.633 22.687h5.876m1.758-3.526a2.35 2.35 0 10-4.7 0v5.29c0 1.947-.404 4.113-2.351 4.113h7.051","stroke-width":"1.714"}}),_c('path',{attrs:{"stroke-width":"2","d":"M34.859 41.149c0 5.523 4.477 10 10 10s10-4.477 10-10-4.477-10-10-10-10 4.477-10 10z"}}),_c('path',{attrs:{"stroke-width":"2","d":"M48.192 41.149h-3.333v-5"}})])])
          )
        }
      }
    